import {combineReducers} from '@reduxjs/toolkit';
import {userContentReducer} from 'src/modules/profile/user/tabs/content/user-content.reducer';

import {assignedAccountsSearchResultReducer} from '../tabs/assigned-accounts';
import {userAuditLogReducer} from '../tabs/audit-log/audit-log.reducer';
import {userEntitlementsReducer} from '../tabs/entitlements';
import {userActivityLogsReducer} from '../tabs/user-activity-log/user-activity-log.reducer';
import {userConferencesReducer} from '../tabs/user-conferences';
import {userEmailDeliveryLogReducer} from '../tabs/user-login/email-history/user-email-delivery-log.reducer';
import {userRoleAuditLogReducer} from '../tabs/user-role-settings/audit-log';

import {userProfileSlice} from './user-profile-slice';

export const userPageTabsReducer = combineReducers({
    userProfile: userProfileSlice.reducer,
    assignedAccounts: assignedAccountsSearchResultReducer,
    userConferences: userConferencesReducer,
    userActivityLogs: userActivityLogsReducer,
    userAuditLog: userAuditLogReducer,
    userRoleAuditLog: userRoleAuditLogReducer,
    userEntitlements: userEntitlementsReducer,
    loginAndPassword: userEmailDeliveryLogReducer,
    content: userContentReducer,
});
